var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"star"},_vm._l((_vm.review),function(item,index){return _c('div',{key:index,staticClass:"star_box"},[_c('img',{staticClass:"img",attrs:{"src":item.url,"alt":""}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }